import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "../ui/dialog";



type DeleteSetModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: () => void;
};

const DeleteSetModal = ({
  onOpenChange,
  open,
  onSubmit,
}: DeleteSetModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 bg-white">
        <DialogTitle className="font-semibold text-lg text-center px-8 pt-8">
          {t("deleteEnsembleTitle")}
        </DialogTitle>

        <div className="p-6">
          <p className="text-sm text-gray-500">
            {t("deleteEnsembleAreYouSureDescription")}
          </p>
        </div>
        <DialogFooter
            className={cn(
              "flex flex-row align-center gap-4 border-t p-6 bg-white",
              "relative before:absolute before:top-[-12px] before:inset-x-0",
              "before:h-3 before:bg-gradient-to-t before:from-black/5 before:to-transparent",
            )}
          >
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex flex-1 bg-white"
            >
              {t("actionCancel")}
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={onSubmit}
              className="flex flex-1"
            >
              {t("deleteEnsembleButton")}
            </Button>
          </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteSetModal;
